import { types } from "@vilocnv/allsetra-core";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { ObjectsState } from "domain/objects/entities/interfaces/object-state.interface";
import getObjectDataForMapAction from "../actions/get-object-data-for-map.action";

const getObjectDataForMapCases = (
  builder: ActionReducerMapBuilder<ObjectsState>
) => {
  builder.addCase(getObjectDataForMapAction.pending, (state) => {
    state.isLoadingObjectDetail = true;
  });
  builder.addCase(getObjectDataForMapAction.fulfilled, (state, action) => {
    const { uniqueId } = action.payload;
    const object = state.objects.find((o) => o.uniqueId === uniqueId);

    if (object) {
      const newObject: types.IObject = {
        ...object,
        location: {
          ...object.location,
          latitude: action.payload.latitude - 0.00001,
          longitude: action.payload.longitude,
          accuracy: action.payload.accuracy,
          resolvedAddress: action.payload.address,
          date: action.payload.date
        },
        metadata: action.payload.metadata,
        uniqueId: action.payload.uniqueId
      };

      state.selectedObject = newObject;
    }
    state.isLoadingObjectDetail = false;
  });
  builder.addCase(getObjectDataForMapAction.rejected, (state) => {
    state.isLoadingObjectDetail = false;
  });
};

export default getObjectDataForMapCases;
